import React, { useState } from 'react';
import { Heading, Box } from '@chakra-ui/react';
import ArticleForm from './ArticleForm';
import axios from '../../axiosConfig';
import { useNavigate } from 'react-router-dom';

const ArticleCreate = () => {
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    setSubmitting(true);
    try {
      await axios.post('/admin/articles', formData);
      navigate('/app/articles');
    } catch (err) {
      console.error('Failed to create article', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <Heading size="lg" mb={6}>
        Create New Article
      </Heading>
      <ArticleForm onSubmit={handleSubmit} isSubmitting={submitting} />
    </Box>
  );
};

export default ArticleCreate;